import { render, staticRenderFns } from "./CollapseDivOne.vue?vue&type=template&id=5d875274"
import script from "./CollapseDivOne.vue?vue&type=script&lang=js"
export * from "./CollapseDivOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports